import { useEffect, useState } from "react";
import { IFilterInvTsReport } from "./Filter";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InvoiceTracking } from "../../invoiceTracking/Table";
import { Fetch } from "../../../shared/Fetch";
import { format } from "date-fns";
import { ILogin } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";

interface IProps {
    open: boolean,
    filters: IFilterInvTsReport,
    login_ID: number,
    toast: any,
}

export const InvoiceUploaded = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: InvoiceTracking[], loading: boolean });

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("InvoiceTracking/invoicesAddedByUser", "GET", null, `filter=` + encodeURIComponent(JSON.stringify(props.filters)) + `&userID=${props.login_ID}`, props.toast);
        if (response) {
            const data: InvoiceTracking[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    const fromDate = (rowData: any) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const toDate = (rowData: any) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const dueDate = (rowData: any) => {
        let date;
        if (rowData.dueDate) date = format(new Date(rowData.dueDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const paymentDate = (rowData: any) => {
        let date;
        if (rowData.payment_Date) date = format(new Date(rowData.payment_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    useEffect(() => {
        if (props.open) {
            loadTableData();
        };
    }, [props.open]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;
    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                value={tableData.tableData}
                loading={tableData.loading}
                stripedRows resizableColumns showGridlines columnResizeMode="expand"
                dataKey="invoice_ID"
            >
                <Column header="SN." body={(rowData, options) => options.rowIndex + 1} footer={"Total Amount"} />
                <Column field="prime_Vendor_Company" header="Prime Vendor" />
                <Column field="consultant_Name" header="Name" />
                <Column field="invoiceNO" header="Invoice#" />
                {/* <Column field="fromDate" header="From Date" body={fromDate} />
                <Column field="toDate" header="To Date" body={toDate} />
                <Column field="dueDate" header="Due Date" body={dueDate} /> */}
                <Column field="fromDate" header="From Date" body={(rowData: any) => safeFormatDate(rowData.fromDate, 'dd/MM/yyyy', DateFormat)} />
                <Column field="toDate" header="To Date" body={(rowData: any) => safeFormatDate(rowData.toDate, 'dd/MM/yyyy', DateFormat)} />
                <Column field="dueDate" header="Due Date" body={(rowData: any) => safeFormatDate(rowData.dueDate, 'dd/MM/yyyy', DateFormat)} />
                <Column field="invoiceHours" header="Hours" />
                <Column field="sRate" header="S.Rate" />
                <Column field="invoiceAmount" header="Inv.Amount" footer={() => {
                    const invAmnt = tableData.tableData.reduce((sum, item) => sum + (item.invoiceAmount || 0), 0);
                    return <span className="">{invAmnt}</span>;
                }} />
                <Column field="receivedAmount" header="Recived Amount" footer={() => {
                    const invRcvAmnt = tableData.tableData.reduce((sum, item) => sum + (item.receivedAmount || 0), 0);
                    return <span className="">{invRcvAmnt}</span>;
                }} />
                <Column field="paidAmount" header="Paid Amount" />
                <Column field="payment_Mode" header="Payment Mode" />
                <Column field="transaction_ID" header="Transaction" />
                <Column field="payment_Date" header="Payment Date" body={paymentDate} />
                <Column field="paymentStatus" header="Payment Status" />
                <Column field="aging" header="Aging" />
                <Column field="" header="Send Email" />
            </DataTable>
        </>
    );
}